import { NamedColor } from './namedColor';

export class ColoredTextItem {
    color: NamedColor;
    text: string;

    constructor(text: string, color: NamedColor) {
      this.text = text;
      this.color = color;
    }
}

export class ColoredTextFindReplaceItem {
  color: NamedColor;
  find: string;
  replace: string;

  constructor(find: string, replace: string,color: NamedColor) {
    this.find = find;
    this.replace = replace;
    this.color = color;
  }
}
export class ColoredNumberFindReplaceItem {
  color: NamedColor;
  find: number;
  replace: number;

  constructor(find: number, replace: number,color: NamedColor) {
    this.find = find;
    this.replace = replace;
    this.color = color;
  }
}

export const NamedColorList = [
      new NamedColor('greenyellow', '#CCFF00'),
      new NamedColor('orange', '#FF9933'),
      new NamedColor('pastelblue', '#3399CC'),
      new NamedColor('pastelgreen', '#99FFCC'),
      new NamedColor('purple', '#CC99FF'),
      new NamedColor('turquoise', '#43C6DB'),
      new NamedColor('pink', '#FFC0CB'),
      new NamedColor('blue', '#0099FF'),
      new NamedColor('fuchsia', '#FF00FF'),
      new NamedColor('pastelyellow', '#FFFF99'),
      new NamedColor('grey', '#AB99BB'), 
      new NamedColor('turquoise2', '#26C49B'),
      new NamedColor('pastelred', '#FF3399'),
      new NamedColor('green', '#00FF00'),
      new NamedColor('blue2', '#006080'),
      new NamedColor('red', '#FF5050'),
      new NamedColor('brown', '#CC9900'),
      new NamedColor('lime', '#99FF33'),
      new NamedColor('purple', '#CC00CC'),
      new NamedColor('yelloworange', '#FCEA04'),
      new NamedColor('blue3', '#6666FF'),
      new NamedColor('lightgrey', '#EAEAEA'),
      new NamedColor('hotpink', '#FF66FF'),
      new NamedColor('lightgreen', '#00FF99'),
      new NamedColor('tangerine', '#FF6600'),
      new NamedColor('cyan', '#00FFFF'),
      new NamedColor('yellow', '#FFFF00'),
      new NamedColor('babyblue', '#CCFFFF'),
      new NamedColor('neongreen', '#00CC00'),
      new NamedColor('tan', '#FFCC99'),
  ];
